module.exports = __webpack_public_path__ + "img/route__all.fdf8e456.svg";